export const safeInt = (value, defaultValue = 0) => {
    if (value === undefined || value === null || value === "") {
        return defaultValue;
    }
    const n = parseInt(value, 10);
    return Number.isFinite(n) ? n : defaultValue;
};